import { Page, registerResultListPage } from "../Page";

export class ResultListPage extends Page {
}

registerResultListPage(ResultListPage);
